import styled from 'styled-components';
import { Typography } from 'design-system/src/components/Typography/Typography';
import Button from 'design-system/src/components/Button/Button';
import { PageContainer } from './styles';
import { SuccessCard } from 'design-system/src/components/SuccessCard/SuccessCard';
import { SignupType } from './utils';
import { useFeatureFlags } from '../../hooks/useFeatureFlags';
import { LoadingSpinner } from 'design-system/src/components/LoadingSpinner/LoadingSpinner';
import { ReturnToHomePageButton } from './ReturnToHomePageButton';

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export type ConfirmationStepProps = {
  className?: string;
  onNext: () => void;
  signupType: SignupType;
};

export const ConfirmationStep = ({ className, onNext, signupType }: ConfirmationStepProps) => {
  const { data: featureFlags, isLoading: isLoadingFeatureFlags } = useFeatureFlags();

  return (
    <PageContainer className={className}>
      <SuccessCard>
        {isLoadingFeatureFlags ? (
          <LoadingSpinner />
        ) : (
          <StyledContent>
            <Typography styledAs="h6">Booked! We're looking forward to showing you how Tandem works.</Typography>
            {signupType === 'smb' && !!featureFlags?.providerSignupFlow ? (
              <>
                <Typography>In the meantime, you can set up your account and practice.</Typography>
                <Button width="full" onClick={onNext}>
                  Set up my account and practice
                </Button>
              </>
            ) : (
              <>
                <Typography>In the meantime, learn more about Tandem and how it can help your practice.</Typography>
                <ReturnToHomePageButton />
              </>
            )}
          </StyledContent>
        )}
      </SuccessCard>
    </PageContainer>
  );
};

export default ConfirmationStep;
